<template>
	<div>
		<div class="x-stat">
			<a-row>
				<a-col :span="3">
					<a-statistic title="数量" :value="totalRow" />
				</a-col>
			</a-row>
		</div>

		<a-card :bordered="false">
			<div class="x-filter">
				<a-form layout="inline">
					<a-row :gutter="24">
						<a-col :span="4">
							<a-form-item label="期号">
								<a-input v-model="queryParams.issue" placeholder="期号" />
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="用户">
								<a-input v-model="queryParams.user" placeholder="ID/账号" />
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="输赢">
								<a-select v-model="queryParams.winLose" placeholder="全部" allowClear>
									<a-select-option value="WIN">赢</a-select-option>
									<a-select-option value="LOST">输</a-select-option>
									<a-select-option value="WAIT">待开</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
                        <template v-if="advanced">
                            <a-col :span="6">
                                <a-form-item label="时间">
                                    <a-range-picker @change="onCreateTime" />
                                </a-form-item>
                            </a-col>
                        </template>
                        <a-col :span="!advanced && 4 || 24">
							<span class="x-filter-submit-box"
                                  :style="advanced && {float:'right', overflow:'hidden'} || {}">
								<a-button type="primary" @click="getTableData">查询</a-button>
								<a-button style="margin-left:8px" @click="() => this.queryParams={}">重置</a-button>
								<a @click="()=>{advanced = !advanced;}" style="margin-left: 8px">
									{{ advanced ? '收起' : '展开' }}
									<a-icon :type="advanced ? 'up' : 'down'" />
								</a>
							</span>
                        </a-col>
					</a-row>
				</a-form>
			</div>

			<a-table
				:rowKey="record => record.id"
				:columns="tableColumns"
				:loading="tableLoading"
				:dataSource="tableData"
				:pagination="false"
			>
				<template slot="user" slot-scope="record">
                    <div class="user">
                        <span>{{ record.userLoginAccount }}</span>
                        -
                        <span>{{ record.userNickname }}</span>
                    </div>
				</template>

				<template slot="winLose" slot-scope="record">
                    <span class="success" v-if="record.winLose == 'WIN'">赢</span>
                    <span class="error" v-else-if="record.winLose == 'LOST'">输</span>
                    <span class="warning" v-else>待开奖</span>
				</template>

				<template slot="changeAmount" slot-scope="record">
					<span class="warning" v-if="record.winLose == 'WAIT'">-</span>
                    <template v-else>
                        <span class="success" v-if="record.changeAmount >= 0">{{ record.changeAmount }}</span>
                        <span class="error" v-else>{{ record.changeAmount }}</span>
                    </template>
				</template>

				<template slot="settle" slot-scope="record">
                    <span v-if="record.isSettle == 'N'">未结算</span>
					<div v-else>
                        <span>已结算</span>
                        <p class="settle-time">{{ record.settleTimeText }}</p>
					</div>
				</template>
			</a-table>

			<div class="x-pagination">
				<a-pagination
					:pageSize="pageSize"
					v-model="pageIndex"
					:total="totalRow"
					@change="pageChange"
					:hideOnSinglePage="true"
					show-less-items
				/>
			</div>
		</a-card>
	</div>
</template>

<script>
import moment from "moment";
import { userBetList } from '@/api/op/bet';

const tableColumns = [
	{ title: '#', dataIndex: 'id' },
    { title: '期号', dataIndex: 'lottoIssue' },
	{ title: '开奖', dataIndex: 'treatedContent' },
	{ title: '用户', scopedSlots: { customRender: 'user' } },
	{ title: '下注项', dataIndex: 'lottoBetName' },
	{ title: '下注金额', dataIndex: 'betAmount' },
	{ title: '赔率', dataIndex: 'odds' },
	{ title: '输赢', scopedSlots: { customRender: 'winLose' } },
	{ title: '变动金额', scopedSlots: { customRender: 'changeAmount' } },
	{ title: '结算', scopedSlots: { customRender: 'settle' } },
	{ title: '创建时间', dataIndex: 'created' },
];

export default {
	data() {
		return {
            advanced: false,
			queryParams: {},
			tableLoading: false,
			tableColumns,
			tableData: [],
			totalRow: 0,
			pageSize: 20,
			pageIndex: 1,
		};
	},
	created() {
		this.getTableData();
	},
	methods: {
        getTableData() {
			this.tableLoading = true;
            this.queryParams.pageSize = this.pageSize;
            this.queryParams.page = this.pageIndex;

			return userBetList(this.queryParams).then((res) => {
				this.tableData = res.data.recordList || [];
				this.totalRow = res.data.totalRow || 0;
			}).finally(() => {
				this.tableLoading = false;
			});
		},
		pageChange(current) {
			this.pageIndex = current;
			this.getTableData();
		},
        onCreateTime(values) {
            this.queryParams.startCreateTime = moment(values[0]).unix();
            this.queryParams.endCreateTime = moment(values[1]).unix();
        },
	},
};
</script>

<style lang="less" scoped>
.settle-time {
    font-size: 12px;
    color: #acacac;
}
</style>
